import type { BiometricDeletionRepository } from '@/modules/admin/domain/repositories/BiometricDeletionRepository';
import type { LocalEmployeeRepository } from '@/modules/employees/infrastructure/repositories/LocalEmployeeRepository';

export interface DeleteNfcBiometricInput {
  idEntity: number;
  idPerson: number;
  idEntityBiometric: number;
}

/**
 * Use case: delete a specific NFC biometric record for an employee.
 *
 * Sequence:
 *  1. Call remote adapter → 404 is already mapped to void (idempotent).
 *  2. Patch local Dexie cache to remove the matching biometric entry.
 *
 * Errors other than 404 propagate as BiometricDeletionError (thrown by the adapter).
 * In that case the local cache is NOT patched (remote state is source of truth).
 *
 * Change: nueva-seccion-de-borrado-perfiles-en-administracion-empleados
 */
export class DeleteNfcBiometricUseCase {
  constructor(
    private readonly biometricDeletionRepo: BiometricDeletionRepository,
    private readonly localEmployeeRepo: Pick<LocalEmployeeRepository, 'removeBiometricData'>,
  ) {}

  async execute(input: DeleteNfcBiometricInput): Promise<void> {
    const { idEntity, idPerson, idEntityBiometric } = input;
    await this.biometricDeletionRepo.deleteNfcBiometric(idEntity, idEntityBiometric);
    await this.localEmployeeRepo.removeBiometricData(idPerson, { kind: 'nfc', idEntityBiometric });
  }
}
